
import { Button } from "@/components/ui/button";
import { Loader2, ChevronLeft, ChevronRight } from "lucide-react";
import { Trans } from "@lingui/macro";
import { cn } from "@/lib/utils";
import React from "react";

interface IntakeNavigationProps {
  onBack?: () => void;
  onNext: () => void;
  isNextDisabled?: boolean;
  isNextLoading?: boolean;
  nextLabel?: React.ReactNode;
  backLabel?: React.ReactNode;
  className?: string;
  showBack?: boolean;
}

export function IntakeNavigation({
  onBack,
  onNext,
  isNextDisabled = false,
  isNextLoading = false,
  nextLabel,
  backLabel,
  className,
  showBack = true,
}: IntakeNavigationProps) {
  return (
    <div className={cn("flex flex-col-reverse sm:flex-row items-center justify-center gap-2 sm:gap-4 pt-8 pb-4 border-t border-gray-100 mt-6", className)}>
      {showBack && onBack && (
        <Button
          type="button"
          variant="outline"
          size="xl"
          onClick={onBack}
          disabled={isNextLoading}
          className="w-full sm:w-auto min-w-[160px] !h-14 px-8 text-base border-2 border-gray-200 text-gray-700 hover:bg-gray-50 hover:text-gray-900 hover:border-gray-300 font-bold transition-all duration-300 rounded-xl transform-none self-center my-0"
        >
          <ChevronLeft className="w-5 h-5 mr-2" />
          {backLabel || <Trans>Back</Trans>}
        </Button>
      )}

      <Button
        type="button"
        size="xl"
        onClick={onNext}
        disabled={isNextDisabled || isNextLoading}
        className={cn(
          "w-full sm:w-auto min-w-[240px] !h-14 px-8 text-base font-bold text-white rounded-xl shadow-none hover:shadow-md transition-all duration-300 transform-none border-2 border-transparent self-center my-0 whitespace-normal leading-tight",
          "bg-gradient-to-r from-[#166B93] via-[#166B93] to-[#145A7A] hover:from-[#145A7A] hover:to-[#166B93]",
          isNextDisabled && "opacity-50 cursor-not-allowed shadow-none"
        )}
      >
        {isNextLoading ? (
          <>
            <Loader2 className="w-5 h-5 mr-2 animate-spin" />
            <Trans>Processing...</Trans>
          </>
        ) : (
          <>
            {nextLabel || <Trans>Continue</Trans>}
            <ChevronRight className="w-5 h-5 ml-2" />
          </>
        )}
      </Button>
    </div>
  );
}
